import { render } from "./HelpCenter.vue?vue&type=template&id=5ac0f1bf&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=ts"
export * from "./HelpCenter.vue?vue&type=script&lang=ts"

import "./HelpCenter.vue?vue&type=style&index=0&id=5ac0f1bf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ac0f1bf"

export default script